import { render, staticRenderFns } from "./ProductSalesPageInstructors.vue?vue&type=template&id=03077c27&scoped=true&"
import script from "./ProductSalesPageInstructors.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageInstructors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03077c27",
  null
  
)

export default component.exports